import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { ChangeEvent, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useBroker } from '../../../../../hooks/useBroker';
import { purposeOptions } from '../../config/globals';
import { PurposeFormGroupData } from '../../FormData.se.types';

export const PurposeField = () => {
  const { t } = useTranslation();

  const broker = useBroker();

  const { setValue } = useFormContext();

  const purposeFieldOptions = useMemo(() => {
    return {
      registerOptions: {
        required: 'Purpose.error.required',

        onChange: (e: ChangeEvent<HTMLInputElement>) => {
          if (!e.target.value) return;
          setValue('LoanApplication/Purpose', e.target.value, {
            shouldDirty: true,
            shouldTouch: true,
            shouldValidate: true,
          });
        },
      },
    };
  }, [setValue]);

  return (
    <DropdownFieldUI<PurposeFormGroupData>
      name="Frontend/PurposeDropdown"
      label={t('Purpose.label')}
      placeholder={t('placeholder')}
      data-testid="purpose-dropdown"
      options={purposeOptions[broker]}
      {...purposeFieldOptions}
    />
  );
};
